module.exports = __webpack_public_path__ + "img/manga-scene.993cc826.jpg";